import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from "../../../components/Modal/ModalComponent/ModalComponent";
import './ModalСonfirmationTemplate.scss'

const ModalСonfirmationTemplate = ({
    setIsModal,
    fetchGetTemplate,
    fetchGetTemplateWithFilters
}) => {

    const onClose = () => {
        setIsModal(false)
    }

    return (
        <ModalComponent
            onClose={onClose}
            title="Выберите действие"
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-confirmation-template'>
                    <div className='modal-confirmation-template__group-btn'>
                        <ButtonBasic
                            blue
                            text='Скачать стандартный шаблон'
                            width='100%'
                            onClick={(e) => {
                                fetchGetTemplate()
                                onClose(false)
                            }}
                        />
                        <ButtonBasic
                            green
                            text='Скачать шаблон с данными из таблицы'
                            width='100%'
                            onClick={(e) => {
                                fetchGetTemplateWithFilters()
                                onClose(false)
                            }}
                        />
                        <ButtonBasic
                            red
                            text='Отмена'
                            width='100%'
                            onClick={(e) => onClose(false)}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalСonfirmationTemplate }